import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sub-event-participant-modal',
  templateUrl: './sub-event-participant.modal.html',
  styleUrls: ['./sub-event-participant.modal.scss'],
  standalone: false
})
export class SubEventParticipantModalComponent {
  subEvents;
  participants;
  eventId;
  eventData;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SubEventParticipantModalComponent>) {
    if (this.data){
      this.subEvents = data.subEvents;
      this.participants = data.participants;
      this.eventId = data.eventId;
      this.eventData = data.eventData;
    }
  }
}
